
<template>
  <div id="basic">
    <div class="banner_bar">
      <h3>外卖菜品信息</h3>
      <el-form>
        <div style="display: flex">
          <el-form-item label="请选择门店" style="margin-right: 20px">
            <el-select
              v-model="formInline.shop_id"
              placeholder="请选择"
              @change="getCategory()"
            >
              <el-option
                v-for="index in typeData"
                v-bind:key="index.id"
                :label="index.name"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div style="display: flex">
          <el-form-item label="请选择标签属性" style="margin-right: 20px">
            <el-select
              v-model="formInline.dish_attr_value_ids"
              placeholder="请先选择标签"
            >
              <el-option
                v-for="index in attrList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="搜索" style="margin-right: 20px">
            <el-input
              placeholder="请输入内容"
              v-model="formInline.name"
            ></el-input>
          </el-form-item>
          <el-form-item
            style="
              min-width: 150px;
              margin-left: 20px;
              display: flex;
              align-items: flex-end;
            "
          >
            <el-button
              type="primary"
              style="background: #1890ff"
              @click="getTableData"
              >查询</el-button
            >
            <el-button type="primary" class="vubutton" @click="setFormInline"
              >重置</el-button
            >
            <!-- <el-button type="primary" style="background: #1890ff;" @click="setFormInlines">查看全部</el-button> -->
          </el-form-item>
        </div>
      </el-form>
      <div style="width: 100%; height: auto; display: flex">
        <div class="webList" v-if="categoryData.length">
          <div class="webList_1">
            <div
              :class="
                (item.id === formInline.category_ids &&
                  'webList_1_name name_color') ||
                'webList_1_name'
              "
              style="cursor: default"
              v-for="(item, index) in categoryData"
              :key="index"
              @click="() => categoryList(item.id)"
            >
              <img class="webList_icon" :src="item.image" />
              {{ item.name }}
            </div>
          </div>
          <div class="webList_2">
            <!-- <div class="webList_1_name" v-for="item in tableData" :key="item.id">{{item.amount}}</div> -->
            <div
              :class="
                (item.id == user_dish_list_id && 'webList_2_list name_color') ||
                'webList_2_list'
              "
              style="cursor: default"
              v-for="item in tableData"
              :key="item.id"
              @click="getEdit(item)"
            >
              <img :src="item.dish_base.image" class="webList_2_img" />
              <div>
                <div class="webList_2_name">
                  {{ item.dish_base.name || '暂无商品名称' }}
                </div>
                <div
                  class="webList_2_value"
                  v-for="items in item.dish_unit_prices"
                  :key="items.id"
                >
                  <div>
                    规格价格：{{ items.price }}元/{{
                      items.dish_unit.unit_amount
                    }}{{ items.dish_unit.name }}
                  </div>
                  <div>计量单位：{{ items.dish_unit.display_name }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_centers_y">
            <div style="flex: 1" class="vubuttons" @click="onSubmit_ca">
              新增类目
            </div>
            <div style="flex: 2" class="vubuttons" @click="onSubmit">
              新增菜品
            </div>
          </div>
        </div>
        <div class="webListValue" v-if="user_dish_list_id && form.id">
          <div class="value_name">{{ form.name }}</div>
          <div class="value_namex">{{ form.intro }}</div>
          <div
            class="value_price"
            v-for="item in form.dish_unit_prices"
            :key="item.id"
          >
            {{ item.dish_unit.unit_amount }}{{ item.dish_unit.name }}/{{
              item.dish_unit.display_name
            }}:
            <div class="value_price_s">价格:{{ item.price }}元</div>
            <div class="value_price_s">(vip:{{ item.vip_price }}元)</div>
          </div>
          <div class="value_price">
            重量偏差:
            <div class="value_price_s">{{ form.deviation }}g</div>
          </div>
          <div class="value_price">
            总重量:
            <div class="value_price_s">{{ form.amount }}g</div>
          </div>
          <!-- <template slot-scope="scope"> -->
          <div class="value_names">菜品标签</div>
          <div class="value_attr">
            <div class="value_attr_s">
              <el-tag
                style="margin-right: 5px"
                closable
                v-for="tag in form.dish_attr_map"
                :key="tag.id"
                @close="deleteLaole(tag.id)"
                >{{ tag.dish_attr_value.value }}</el-tag
              >
            </div>
          </div>
          <div class="value_names">所属类目</div>
          <div class="value_attr">
            <div class="value_attr_s" style="justify-content: center">
              <el-tag
                style="margin-right: 5px"
                closable
                v-for="tag in form.category_dishes"
                :key="tag.id"
                @click="setCategory(tag)"
                @close="deleteCategory(tag.id)"
                >{{ tag.category.name }}</el-tag
              >
            </div>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>卡路里</div>
              <div>{{ form.calorie }}卡</div>
            </div>
            <el-progress
              :percentage="form.calorie"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>碳水化合物</div>
              <div>{{ form.carbohydrate }}g</div>
            </div>
            <el-progress
              :percentage="form.carbohydrate"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>蛋白质</div>
              <div>{{ form.protein }}g</div>
            </div>
            <el-progress
              :percentage="form.protein"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div class="value_progress">
            <div class="value_progress_top">
              <div>脂肪</div>
              <div>{{ form.fat }}g</div>
            </div>
            <el-progress
              :percentage="form.fat"
              :color="customColors"
              :text-inside="true"
              :stroke-width="20"
            ></el-progress>
          </div>
          <div
            class="value_attr_s"
            style="justify-content: center; margin-top: 10px"
          >
            <el-button
              size="mini"
              style="margin-top: 5px"
              @click="setCategorys(form)"
              >新增所属类目</el-button
            >
            <el-button
              size="mini"
              style="margin-top: 5px"
              @click="setLaole(form.id)"
              >新增标签</el-button
            >
            <el-button
              size="mini"
              style="margin-top: 5px"
              @click="handleEdit(form)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              style="margin-top: 5px"
              @click="handleDelete(form)"
              >删除</el-button
            >
          </div>
        </div>
      </div>
    </div>
    <!-- 列表弹框 -->
    <el-dialog
      title="菜品信息"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="ruleForm">
        <el-form-item
          label="基础菜品搜索"
          :label-width="formLabelWidth"
          v-if="!putStatus"
        >
          <el-autocomplete
            v-model="form.searchAsync"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入内容"
            @select="handleSelect"
          ></el-autocomplete>
        </el-form-item>
        <el-form-item
          label="堂食外卖"
          :label-width="formLabelWidth"
          prop="category_id"
        >
          <div style="color: #999">外卖</div>
        </el-form-item>
        <el-form-item label="菜品名" :label-width="formLabelWidth" prop="name">
          <el-input v-model="form.name" autocomplete="off"></el-input>
        </el-form-item>
        <div style="width: 110px; text-align: right; margin-bottom: 20px">
          基础配置
        </div>
        <el-form-item label :label-width="'30px'">
          <el-form-item
            label="请选择标签"
            :label-width="formLabelWidth"
            prop="dish_attr_id"
          >
            <el-select
              v-model="form.dish_attr_id"
              placeholder="请选择"
              multiple
            >
              <el-option
                v-for="index in attrList"
                v-bind:key="index.id"
                :label="index.value"
                :value="index.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="菜品规格"
            style="margin-top: 20px"
            :label-width="formLabelWidth"
            prop="dish_unit_id"
          >
            <el-select
              multiple
              :multiple-limit="1"
              v-model="form.dish_unit_id"
              placeholder="请选择"
              @change="getdish_unit_id"
            >
              <el-option
                v-for="index in unitData"
                v-bind:key="index.id"
                :label="`${index.unit_amount}${index.name}/${index.display_name}`"
                :value="index.id"
              ></el-option>
            </el-select>
            <div
              v-for="index in unitList"
              :key="index.id"
              style="display: flex"
            >
              <el-form-item
                :label="`${index.unit_amount}${index.name}/${index.display_name}/价格`"
                :label-width="'150px'"
                style="margin-top: 10px"
              >
                <div style="display: flex">
                  <el-input
                    style="flex: 1"
                    v-model="index.price"
                    type="number"
                    autocomplete="off"
                  ></el-input>
                  <span style="margin-left: 5px">元</span>
                </div>
              </el-form-item>
              <el-form-item
                :label="`${index.unit_amount}${index.name}/${index.display_name}/vip价格`"
                :label-width="'150px'"
                style="margin-top: 10px"
              >
                <div style="display: flex">
                  <el-input
                    style="flex: 1"
                    v-model="index.vip_price"
                    type="number"
                    autocomplete="off"
                  ></el-input>
                  <span style="margin-left: 5px">元</span>
                </div>
              </el-form-item>
            </div>
          </el-form-item>
        </el-form-item>

        <el-form-item
          label="创建时间"
          v-if="form.created_at"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.created_at"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item
          label="更新时间"
          v-if="form.updated_at"
          :label-width="formLabelWidth"
        >
          <el-input
            v-model="form.updated_at"
            autocomplete="off"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth" prop="intro">
          <el-input v-model="form.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="图片" :label-width="formLabelWidth">
          <el-upload
            :action="'https://upload-z2.qiniup.com'"
            list-type="picture-card"
            :auto-upload="true"
            :file-list="fileList"
            :on-success="topSuccess"
            :on-error="topSuccess"
            :before-upload="QiniuToken"
            :data="QiniuData"
            :limit="1"
          >
            <i slot="default" class="el-icon-plus"></i>
            <div slot="file" slot-scope="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
              <span class="el-upload-list__item-actions">
                <span
                  class="el-upload-list__item-preview"
                  @click="handlePictureCardPreview(file)"
                >
                  <i class="el-icon-zoom-in"></i>
                </span>
                <span
                  class="el-upload-list__item-delete"
                  @click="handleRemove(file)"
                >
                  <i class="el-icon-delete"></i>
                </span>
              </span>
            </div>
          </el-upload>
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>

        <el-form-item
          label="外卖起售量"
          :label-width="formLabelWidth"
          prop="minimum_selling"
        >
          <div style="display: flex; width: 200px">
            <el-input
              v-model="form.minimum_selling"
              autocomplete="off"
            ></el-input>
            <span style="margin-left: 5px">份</span>
          </div>
        </el-form-item>
        <el-form-item
          label="外卖增量"
          :label-width="formLabelWidth"
          prop="increment_selling"
        >
          <div style="display: flex; width: 200px">
            <el-input
              v-model="form.increment_selling"
              autocomplete="off"
            ></el-input>
            <span style="margin-left: 5px">份</span>
          </div>
        </el-form-item>

        <el-form-item
          label="请选择类目"
          :label-width="formLabelWidth"
          prop="category_id"
        >
          <el-select v-model="form.category_id" placeholder="请选择" multiple>
            <el-option
              v-for="index in categoryData"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item
          label="卡路里"
          :label-width="formLabelWidth"
          prop="calorie"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.calorie" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">卡</span>
          </div>
        </el-form-item>
        <el-form-item label="油" :label-width="formLabelWidth" prop="oil">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.oil" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="盐" :label-width="formLabelWidth" prop="salt">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.salt" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="糖" :label-width="formLabelWidth" prop="sugar">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.sugar" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 50px">g</span>
          </div>
        </el-form-item>
        <el-form-item label="脂肪" :label-width="formLabelWidth" prop="fat">
          <div style="display: flex; width: 200px">
            <el-input v-model="form.fat" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="碳水化合物"
          :label-width="formLabelWidth"
          prop="carbohydrate"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.carbohydrate" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="蛋白质"
          :label-width="formLabelWidth"
          prop="protein"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.protein" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="纳"
          :label-width="formLabelWidth"
          prop="rest_content"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.rest_content" autocomplete="off"></el-input>
            <span style="margin-left: 5px; width: 30px">mg</span>
          </div>
        </el-form-item>
        <el-form-item
          label="重量偏差"
          v-if="isInput"
          :label-width="formLabelWidth"
          prop="deviation"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.deviation" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
        <el-form-item
          label="总重量"
          v-if="isInput"
          :label-width="formLabelWidth"
          prop="amount"
        >
          <div style="display: flex; width: 200px">
            <el-input v-model="form.amount" autocomplete="off"></el-input>
            <span style="margin-left: 5px">g</span>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="statusStore('ruleForm')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 类目弹框 -->
    <el-dialog title="选择类目" :visible.sync="dialogFormVisibles">
      <el-form>
        <el-form-item label="请选择类目">
          <el-select v-model="categorySet.category_id" placeholder="请选择">
            <el-option
              v-for="index in categoryData"
              v-bind:key="index.id"
              :label="index.name"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibles = false">取 消</el-button>
        <el-button type="primary" v-if="putCategoryTest" @click="putCategory"
          >确 定</el-button
        >
        <el-button type="primary" v-if="!putCategoryTest" @click="postCategory"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 标签弹框 -->

    <el-dialog title="标签属性" :visible.sync="dialogFormVisibleLabel">
      <el-form>
        <el-form-item label="请选择标签属性" style="margin-right: 20px">
          <el-select
            v-model="Label_dish_attr.dish_attr_value_id"
            placeholder="请先选择标签"
          >
            <el-option
              v-for="index in attrList"
              v-bind:key="index.id"
              :label="index.value"
              :value="index.id"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleLabel = false">取 消</el-button>
        <el-button type="primary" v-if="!putCategoryTest" @click="postLaole"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- //新增菜 -->
    <el-dialog title="类目信息" :visible.sync="dialogFormVisible_ca">
      <el-form :model="ca_form">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="ca_form.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="简介" :label-width="formLabelWidth">
          <el-input v-model="ca_form.intro" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="堂食外卖" :label-width="formLabelWidth">
          <el-select v-model="ca_form.c_type" placeholder="请选择">
            <el-option label="堂食" :value="1"></el-option>
            <el-option label="外卖" :value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noStatus()">取 消</el-button>
        <el-button type="primary" @click="setStore_ca()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script scoped>
import fecha from 'element-ui/src/utils/date';
export default {
  data() {
    return {
      platform: '',
      //列表数据
      tableData: [],
      // 门店数据
      typeData: [],

      // 类目数据
      categoryData: [],
      //单位数据
      unitData: [],
      // 绑定参数
      formInline: {
        // 门店
        shop_id: 0,
        //搜索
        name: '',
        //类目
        category_ids: '',
        //标签
        dish_attr_value_ids: '',
      },
      // 弹窗控住
      dialogFormVisible: false,
      dialogFormVisible_ca: false,
      dialogFormVisibles: false,
      dialogFormVisibleLabel: false,
      // 类目
      categorySet: {},
      //标签属性
      Label_dish_attr: {
        dish_attr_id: '',
        dish_attr_value_id: '',
      },
      putCategoryTest: false,
      // 弹窗数据
      form: {
        name: '',
        intro: '',
        image: '',
        price: 0,
        calorie: 0,
        fat: 0,
        carbohydrate: 0,
        protein: 0,
        rest_content: 0,
        deviation: 0,
        dish_unit_id: [],
        amount: 0,
        action_type: 1, //1不置顶 2制定
        category_id: [],
        dish_attr_id: [],
        sticky: 1,
        order_seq: 22,
        minimum_selling: 0,
        increment_selling: 0,
        dish_base_id: '',
        oil: 0,
        salt: 0,
        sugar: 0,
      },
      // 类目新增
      ca_form: {},
      // 宽度
      formLabelWidth: '120px',
      // 是否修改
      putStatus: false,
      unitList: [],
      //七牛
      fileList: [],
      dialogVisible: false,
      dialogImageUrl: '',

      QiniuData: {
        // key: '', //图片名字处理
        token: '', //七牛云token
      },
      rules: {
        name: [
          { required: true, message: '请输入菜品名', trigger: 'blur' },
          // { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        intro: [{ required: true, message: '请输入简介', trigger: 'blur' }],
        minimum_selling: [
          { required: true, message: '外卖起售量不能为空', trigger: 'blur' },
        ],
        increment_selling: [
          { required: true, message: '外卖增量不能为空', trigger: 'blur' },
        ],
        category_id: [
          { required: true, message: '类目不能为空', trigger: 'blur' },
        ],

        dish_attr_id: [
          { required: true, message: '标签不能为空', trigger: 'blur' },
        ],
        dish_unit_id: [
          { required: true, message: '菜品规格不能为空', trigger: 'blur' },
        ],
        calorie: [
          { required: true, message: '卡路里不能为空', trigger: 'blur' },
        ],
        oil: [{ required: true, message: '油不能为空', trigger: 'blur' }],
        salt: [{ required: true, message: '盐不能为空', trigger: 'blur' }],
        sugar: [{ required: true, message: '糖不能为空', trigger: 'blur' }],
        fat: [{ required: true, message: '脂肪不能为空', trigger: 'blur' }],
        carbohydrate: [
          { required: true, message: '碳水化合物不能为空', trigger: 'blur' },
        ],
        protein: [
          { required: true, message: '蛋白质不能为空', trigger: 'blur' },
        ],
        rest_content: [
          { required: true, message: '剩余内容不能为空', trigger: 'blur' },
        ],
        deviation: [
          { required: true, message: '重量偏差不能为空', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '总重量不能为空', trigger: 'blur' },
        ],
      },
      user_dish_list_id: '',
      customColors: [
        { color: '#0dce8c', percentage: 40 },
        { color: '#2782e8', percentage: 80 },
        { color: '#ff0000', percentage: 100 },
      ],
      attrList: [],
      isInput: true,
    };
  },
  methods: {
    querySearchAsync(queryString, cb) {
      var restaurants = [];
      if (queryString) {
        this.getDishBase(queryString, (item) => {
          if (item) {
            item.data.items.map((items) => (items.value = items.name));
            cb(item.data.items || []);
          } else {
            cb([]);
          }
        });
      }
    },
    handleSelect(item) {
      this.form.name = item.name;
      this.form.intro = item.intro;
      this.form.calorie = item.calorie;
      this.form.carbohydrate = item.carbohydrate;
      this.form.fat = item.fat;
      this.form.protein = item.protein;
      (this.form.oil = item.oil),
        (this.form.salt = item.salt),
        (this.form.sugar = item.sugar),
        (this.form.rest_content = item.rest_content);
      this.form.dish_base_id = item.id;
      this.fileList = [
        {
          url: item.image,
          response: { key: item.image },
        },
      ];
      console.log(item, this.form);
    },
    testData(data) {
      let test = true;
      for (let index in data) {
        if ((!data[index] && data[index] !== 0) || data[index] === null) {
          test = false;
        }
      }
      return test;
    },
    setStore_ca() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_list_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines_list
      }

      const datas = {
        name: this.ca_form.name,
        intro: this.ca_form.intro,
        c_type: this.ca_form.c_type,
        shop_id: this.formInline.shop_id,
        order_seq: 23,
        parent_id: 0,
      };
      console.log(datas);
      if (!this.testData(datas)) {
        this.$alert('类目信息不能为空');
        return;
      }
      this.$http.post(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible_ca = false;
          this.getCategory();
          return;
        }
        if (res.code !== 200) {
          this.$alert('新增类目失败');
        }
        console.log(res);
      });
    },
    setForm_ca() {
      this.ca_form = {
        name: '',
        c_type: 1,
      };
    },
    onSubmit_ca() {
      this.dialogFormVisible_ca = true;
      this.setForm_ca();
    },
    categoryList(id) {
      this.formInline.category_ids = id;
      this.user_dish_list_id = '';
      this.form = {};
      this.getTableData();
    },
    getdish_unit_id() {
      let list = this.form.dish_unit_id.map((item) => {
        if (this.unitData.find((items) => items.id === item)) {
          const value = this.unitData.find((items) => items.id === item);
          return {
            created_at: value.value,
            display_name: value.display_name,
            id: value.id,
            name: value.name,
            unit_amount: value.unit_amount,
            updated_at: value.updated_at,
          };
        }
      });
      list = list.map((item) => {
        const test = this.unitList.find((items) => items.id === item.id);
        if (test) {
          test.price && (item.price = test.price);
          test.vip_price && (item.vip_price = test.vip_price);
        }
        return item;
      });

      this.unitList = list;
      const isInput = this.unitData.find((item) => {
        if (
          item.id === this.form.dish_unit_id[0] &&
          item.unit_amount === 50 &&
          item.name == '克'
        ) {
          return item;
        }
      });
      if (isInput) {
        this.isInput = false;
      } else {
        this.isInput = true;
      }
    },
    // 点击标签属性
    setLaole(id) {
      this.dialogFormVisibleLabel = true;
      this.Label_dish_attr = {
        dish_attr_id: '',
        dish_attr_value_id: '',
        dish_id: id,
      };
    },
    // 获取单位列表
    getUnitData() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_unit_platform
      } else {
        baseUrl = this.$userList.user_dish_unit
      }

      const url = baseUrl + '/1/900';
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.unitData = res.data.items;
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    //新增标签属性
    postLaole() {
      const { dish_attr_value_id } = this.Label_dish_attr;
      console.log(this.Label_dish_attr);
      if (!dish_attr_value_id) {
        this.$alert('标签或标签属性不能为空');
        return;
      }
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_map_platform
      } else {
        baseUrl = this.$userList.user_dish_attr_map
      }

      const value = this.attrList.find(
        (item) => item.id === dish_attr_value_id
      );
      const data = {
        dish_attr_id: value.dish_attr_id,
        dish_attr_value_id: value.id,
        dish_id: this.Label_dish_attr.dish_id,
      };
      this.$http.post(baseUrl, data).then(() => {
        this.getTableData();
        console.log(this.categorySet, '???');
        this.dialogFormVisibleLabel = false;
      });
    },
    deleteLaole(id) {
      this.$confirm('此操作将删除标签属性, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_attr_map_platform
        } else {
          baseUrl = this.$userList.user_dish_attr_map
        }
        const url = baseUrl + '/' + id;

        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除失败');
          }
        });
      });
    },
    //修改商品类目
    setCategory(index) {
      this.dialogFormVisibles = true;
      console.log(this.categorySet, '???');
      this.categorySet = index;
      this.putCategoryTest = true;
    },
    //新增商品类目
    setCategorys(index) {
      this.dialogFormVisibles = true;
      this.categorySet = index;
      this.categorySet.category_id = '';
      this.putCategoryTest = false;
    },
    postCategory() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_category_dish_platform
      } else {
        baseUrl = this.$userList.user_category_dish
      }
      if (!this.categorySet.category_id) {
        this.$alert('所属类目不能为空');
        return;
      }
      const data = {
        category_id: this.categorySet.category_id,
        dish_id: this.categorySet.id,
        order_seq: 23,
        sticky: 1,
      };
      this.$http.post(baseUrl, data).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisibles = false;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    putCategory() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_category_dish_platform
      } else {
        baseUrl = this.$userList.user_category_dish
      }

      if (!this.categorySet.category_id) {
        this.$alert('所属类目不能为空');
        return;
      }
      const data = {
        category_id: this.categorySet.category_id,
        dish_id: this.categorySet.dish_id,
        order_seq: this.categorySet.order_seq,
        sticky: this.categorySet.sticky,
        id: this.categorySet.id,
      };
      this.$http.put(baseUrl, data).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisibles = false;
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    deleteCategory(id) {
      this.$confirm('此操作将删除类目, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_category_dish_platform
        } else {
          baseUrl = this.$userList.user_category_dish
        }
        const url = baseUrl+ '/' + id;
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除失败');
          }
        });
      });
    },
    setFormInline() {
      this.formInline.name = '';
      this.formInline.dish_attr_value_ids = '';
      this.formInline.dish_attr_id = '';
      this.getTableData();
    },
    setFormInlines() {
      this.formInline = {
        // 门店
        shop_id: 0,
        //搜索
        name: '',
        //类目
        category_ids: '',
        //标签
        dish_attr_value_ids: '',
      };
      this.getTableData();
    },
    //获取门店
    getType() {
      const url = this.$userList.user_restaurant_list + `/0/999`;
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          this.typeData = res.data.items;
          this.formInline.shop_id = res.data.items[0].id;
          this.getCategory();
        } else {
          res.message && this.$alert(res.message);
        }
      });
      // if (this.platform === '1') {
      //   this.getCategory();
      // } else {
      //   this.$http.get(url).then((res) => {
      //     if (res.code === 200) {
      //       this.typeData = res.data.items;
      //       this.formInline.shop_id = res.data.items[0].id;
      //       this.getCategory();
      //     } else {
      //       res.message && this.$alert(res.message);
      //     }
      //   });
      // }

    },
    //获取基础菜品
    getDishBase(query_text, fn) {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_base_platform
      } else {
        baseUrl = this.$userList.user_dish_base
      }
      this.$http
        .post(baseUrl, {
          shop_id: this.formInline.shop_id,
          query_text,
        })
        .then((res) => {
          if (res.code === 200) {
            fn(res);
          } else {
            fn(false);
          }
        });
    },

    getLabelList() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_label_list_platform
      } else {
        baseUrl = this.$userList.user_label_list
      }

      const _this = this;
      const data = {
        shop_id: this.formInline.shop_id,
      };
      this.$http.post(baseUrl, data).then((res) => {
        if (res.code === 200) {
          _this.attrList = res.data.items || [];
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    //获取类目getLabelgetCategory
    getCategory() {
      this.formInline.category_ids = '';
      let data = {
        parent_id: 0,
        shop_id: this.formInline.shop_id,
        menu_id: 0,
        category_type: 2,
      };

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_menu_cuisines_platform
      } else {
        baseUrl = this.$userList.user_menu_cuisines
      }

      const url = baseUrl + '/0/998';


      this.$http.get(url, data).then((res) => {
        if (res.code === 200) {
          this.categoryData = res.data.items;
          this.formInline.category_ids =
            (res.data.items.length && res.data.items[0].id) || '';
          this.formInline.dish_attr_value_ids = '';
          this.formInline.dish_attr_id = '';
          this.form = {};
          this.getLabelList();
          this.getTableData();
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },
    // 获取列表
    getTableData() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_list_platform
      } else {
        baseUrl = this.$userList.user_dish_list
      }
      const url = baseUrl + '/0/99';

      const data = {
        // 门店
        shop_id: this.formInline.shop_id,
        //搜索
        name: this.formInline.name,
        //类目
        category_ids: this.formInline.category_ids,
        //标签
        dish_attr_value_ids: this.formInline.dish_attr_value_ids,
      };
      this.$http.get(url, data).then((res) => {
        if (res.code === 200) {
          this.tableData =
            (res.data.items &&
              res.data.items.map((items) => {
                items.created_at = fecha.format(
                  new Date(items.created_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.updated_at = fecha.format(
                  new Date(items.updated_at),
                  'yyyy-MM-dd HH:mm:ss'
                );
                items.dish_unit_prices = items.dish_unit_prices.map((item) => {
                  item.price = item.price / 100;
                  item.vip_price = item.vip_price / 100;
                  return item;
                });
                return items;
              })) ||
            [];
          if (this.form.id) {
            this.getEdit(this.form);
          }
        } else {
          res.message && this.$alert(res.message);
        }
      });
    },

    //详细信息
    getEdit(row) {
      // this.putStatus = true;

      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }
      const url = baseUrl + '/' + row.id;
      this.user_dish_list_id = row.id;
      console.log(this.user_dish_list_id, '??');
      this.$http.get(url).then((res) => {
        if (res.code === 200) {
          res.data.getEdit = true;
          res.data.created_at = fecha.format(
            new Date(res.data.created_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.updated_at = fecha.format(
            new Date(res.data.updated_at),
            'yyyy-MM-dd HH:mm:ss'
          );
          res.data.dish_unit_prices = res.data.dish_unit_prices.map((item) => {
            item.price = item.price / 100;
            item.vip_price = item.vip_price / 100;
            return item;
          });
          this.listZ(res.data);
          // this.dialogFormVisible = true;
          const isInput = this.unitData.find((item) => {
            if (
              item.id === this.form.dish_unit_id[0] &&
              item.unit_amount === 50 &&
              item.name == '克'
            ) {
              return item;
            }
          });
          if (isInput) {
            this.isInput = false;
          } else {
            this.isInput = true;
          }
          this.putStatus = true;
          return;
        }
        if (res.code !== 200) {
          this.$alert('获取详细信息失败');
        }
      });
    },
    listZ(data) {
      const list = [];
      data.dish_unit_id = data.dish_unit_prices.map((item) => {
        list.push({
          display_name: '',
          id: item.dish_unit_id,
          name: item.dish_unit.name,
          unit_amount: item.dish_unit.unit_amount,
          price: item.price,
          vip_price: item.vip_price,
        });

        return item.dish_unit_id;
      });
      this.unitList = list;
      data.category_id = data.category_dishes.map((item) => item.category_id);
      data.dish_attr_id = [
        ...new Set(data.dish_attr_map.map((item) => item.dish_attr_value_id)),
      ];
      data.increment_selling;
      data.minimum_selling;
      data.dish_base_id = data.dish_base.id;
      const a = {
        ...data.dish_base,
        ...data,
      };
      console.log(a, '???');
      this.form = a;
      this.fileList = [
        {
          url: data.dish_base.image,
          response: { key: data.dish_base.image },
        },
      ];
    },
    //打开编辑弹窗
    handleEdit(form) {
      this.dialogFormVisible = true;
      this.putStatus = true;
      this.getEdit(form);
    },
    //删除
    handleDelete(row) {
      this.$confirm('此操作将删除菜品, 是否继续?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        let baseUrl = ''
        if (this.platform === '1') {
          baseUrl =  this.$userList.user_dish_attr_platform
        } else {
          baseUrl = this.$userList.user_dish_attr
        }
        const url = baseUrl + '/' + row.id;
        this.$http.delete(url).then((res) => {
          if (res.code === 200) {
            this.form = {};
            this.getTableData();
            return;
          }
          if (res.code !== 200) {
            this.$alert('删除菜品失败');
          }
        });
      });
    },
    // 取消
    noStatus() {
      this.dialogFormVisible = false;
      this.dialogFormVisible_ca = false;
    },
    setForm() {
      this.form = {
        name: '',
        searchAsync: '',
        amount: 50,
        deviation: 0,
      };
      this.fileList = [];
      this.unitList = [];
    },
    onSubmit() {
      this.dialogFormVisible = true;
      this.putStatus = false;
      this.setForm();
    },
    statusStore(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (!this.putStatus) {
            this.setStore();
          } else {
            this.putDtore();
          }
        } else {
          return false;
        }
      });
    },
    setStore() {
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }
      let datas = this.getDatas();
      datas.dish.dish_base_id = this.form.dish_base_id;
      this.$http.post(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          1;
          this.$alert('新增菜品失败');
        }
      });
    },
    getDatas(id) {
      let datas = {
        dish: {
          id,
          dish_base: {
            name: this.form.name,
            shop_id: this.formInline.shop_id,
            intro: this.form.intro,
            image: (this.fileList.length && this.fileList[0].url) || '',
            calorie: +this.form.calorie,
            fat: +this.form.fat,
            carbohydrate: +this.form.carbohydrate,
            // 员工增加一个字段card（员工卡）。菜品增加3个字段oil（油）, salt（盐）, （糖）和卡路里并列
            protein: +this.form.protein,
            oil: +this.form.oil,
            salt: +this.form.salt,
            sugar: +this.form.sugar,
            rest_content: +this.form.rest_content,
            id: this.form.dish_base_id,
          },
          dish_base_id: this.form.dish_base_id,
          deviation: +this.form.deviation,
          amount: +this.form.amount,
          minimum_selling: +this.form.minimum_selling,
          increment_selling: +this.form.increment_selling,
        },
        dish_categories:
          (this.form.category_id &&
            this.form.category_id.map((item) => {
              return {
                category_id: +item,
                sticky: 1,
                order_seq: 22,
              };
            })) ||
          [],
        dish_attr_maps: [],
        dish_unit_prices:
          (this.unitList.length &&
            this.unitList.map((item) => {
              return {
                dish_unit_id: item.id,
                price: +(+item.price * 100).toFixed(0),
                vip_price: +(+item.vip_price * 100).toFixed(0),
                type: 2,
                order_seq: 1,
              };
            })) ||
          [],
      };
      this.attrList.map((item) => {
        const value = this.form.dish_attr_id.find((items) => items === item.id);
        if (value)
          datas.dish_attr_maps.push({
            dish_attr_id: item.dish_attr_id,
            dish_attr_value_id: item.id,
          });
      });
      if (!this.putStatus) {
        datas.dish.dish_type = 2;
      }
      return datas;
    },
    putDtore() {
      const datas = this.getDatas(this.form.id);
      console.log(datas, this.form);
      let baseUrl = ''
      if (this.platform === '1') {
        baseUrl =  this.$userList.user_dish_attr_platform
      } else {
        baseUrl = this.$userList.user_dish_attr
      }
      this.$http.put(baseUrl, datas).then((res) => {
        if (res.code === 200) {
          this.dialogFormVisible = false;
          this.getTableData();
          return;
        }
        if (res.code !== 200) {
          this.$alert('修改菜品失败');
        }
      });
    },
    // 七牛
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    topSuccess(event, file, fileList) {
      this.fileList = fileList.map((item) => {
        if (item.response) {
          item.name = item.response.hash;
          item.url = this.QiniuData.url_prefix + '/' + item.response.hash;
        }
        return item;
      });
    },
    async QiniuToken() {
      const url = this.$userList.user_status_qiniutoken_dish;
      const data = await this.$http.get(url).then((res) => {
        return res;
      });
      if (data.code === 200 && data.data.up_token) {
        this.QiniuData.token = data.data.up_token;
        this.QiniuData.url_prefix = data.data.url_prefix;
        return true;
      } else {
        return false;
      }
    },
    handleRemove(file) {
      this.fileList = this.fileList.filter((item) => {
        if (item.name !== file.name) {
          return item;
        }
      });
    },
  },
  created() {
    this.$root.setheadName();
    let platform = this.$route.query.platform
    console.log("platform is :", platform)
    this.platform = platform
    this.getType();
    this.getUnitData();
  },
};
</script>

<style >
#basic {
  width: 100%;
  height: auto;
  position: relative;
}
input:disabled {
  border: 1px solid #ddd;
  background-color: #f5f5f5;
  color: #aca899;
}
.banner_bar {
  width: 100%;
  height: auto;
  background: #fff;
  min-height: 800px;
  box-sizing: border-box;
  padding: 20px;
}
.top_button {
  width: 100%;
  min-height: 300px;
  display: flex;
}
.button_a {
  width: 300px;
  height: auto;
  border: solid 1px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-right: 50px;
  margin-bottom: 50px;
}
.button_top {
  width: 100%;
  height: 64px;
  border-bottom: solid 1px rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 0 16px;
}
.button_push {
  width: 63px;
  height: 32px;
  background: #1890ff;
  color: #fff;
  text-align: center;
  line-height: 32px;
  border-radius: 10px;
}
.banner_ul {
  width: 100%;
  height: auto;
}
.banner_ul li {
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 20px;
  line-height: 40px;
}
.li_icon i {
  margin-right: 10px;
  width: 16rpx !important;
  height: 16rpx !important;
}
.colorli {
  background: rgba(127, 125, 243, 0.3);
}
.bottoms {
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  height: 100%;
  height: 20px;
}
.webList {
  width: 500px;
  height: 700px;
  display: flex;
  border: solid 1px #000;
  overflow: hidden;
  position: relative;
  background: url('../../assets/background.jpg') no-repeat;
  background-size: 100% 100%;
}
.webList_1 {
  flex: 1;
  height: 100%;
  overflow-x: auto;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_1_name {
  height: 50px;
  line-height: 50px;
  color: #fff;
  display: flex;
  align-items: center;
}
.name_color {
}
.webList_2 {
  flex: 2;
  height: 100%;
  overflow-x: auto;
  position: relative;
  box-sizing: border-box;
  padding-bottom: 50px;
}
.webList_icon {
  width: 30px;
  height: 30px;
  background: #fff;
  margin: 0 10px;
}
.webList_2_list {
  width: 100%;
  height: auto;
  color: #fff;
  box-sizing: border-box;
  padding: 20px;
  display: flex;
}
.webList_2_img {
  background: #fff;
  width: 100px;
  height: 100px;
  margin-right: 20px;
}
.webList_2_name {
  font-size: 25px;
  font-weight: 900;
}
.webList_2_value {
  border-top: solid 1px rgba(197, 197, 197, 0.5);
  padding-top: 4px;
}
.webListValue {
  width: 500px;
  height: 700px;
  background: url('../../assets/background.jpg') no-repeat;
  background-size: 100% 100%;
  color: #fff;
  margin-left: 20px;
  overflow-x: auto;
}
.value_name {
  width: 100%;
  text-align: center;
  font-size: 30px;
  font-weight: 900;
  margin-top: 40px;
  margin-bottom: 10px;
}
.value_namex {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin-bottom: 20px;
}
.value_names {
  width: 100%;
  text-align: center;
  font-size: 20px;
  font-weight: 900;
  margin: 10px 0;
}
.value_price {
  color: #ff7207;
  font-size: 20px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}
.value_price_s {
  /* font-size: 35px;
  font-weight: 900;
  line-height: 35px; */
  margin-right: 10px;
}
.value_attr {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
  margin-top: 20px;
}
.value_attr_s {
  overflow-y: auto;
  display: flex;
}
.value_progress {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px;
}
.value_progress_top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
}
.bottom_centers_y {
  width: 100%;
  height: 40px;
  position: absolute;
  bottom: 10px;
  left: 0;
  display: flex;
}
.vubuttons {
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #fff;
  background: #1789fb;
  box-sizing: border-box;
  margin: 0 20px;
  border-radius: 10px;
}
.dishAttrValue {
  display: flex;
  box-sizing: border-box;
  padding-left: 130px;
  flex-wrap: wrap;
}
</style>
